import styled, { css } from 'styled-components';

export const Frame = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background: white;

	${({ size }) => size && css`
		width: ${size}px;
		height: ${size}px;
		min-width: ${size}px;
	`}

	${({ gravatarError }) => !gravatarError && css`
		box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.3);
		border-radius: 50%;
		overflow: hidden;
	`}
`;
